module.exports = __webpack_public_path__ + "img/logo_blanco.b64d7fed.png";